//import logo from './logo.svg';
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Container, Nav, Navbar, Col, Row } from "react-bootstrap";
import { auth, db } from "./firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import { onAuthStateChanged, signOut } from "firebase/auth";
import Home from "./components/Home";
import SignIn from "./components/SignIn";
import SignOut from "./components/SignOut";
import Logo from "./components/Logo";
import Registration1 from "./components/Registration1";
import ImageUploadModal from "./components/ImageUploadModal";
import ImageUpload from "./components/ImageUpload";
import EditUserProfile from "./components/EditUserProfile";
import Gallery from "./components/Gallery";
import UserProfile from "./components/UserProfile";
import ArtistsList from "./components/ArtistsList";
import MembersList from "./components/MembersList";
import ForgotPassword from "./components/ForgotPassword";
import TermsConditions from "./components/TermsConditions";
import GuestArtistsList from "./components/GuestArtistList";
import BioGenerator from "./components/BioGenerator";
import TestFunctions from "./components/TestFunctions";
import Footer from "./components/Footer";
import { BsFillFilePersonFill } from "react-icons/bs";
import { FaSignOutAlt } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { FaSignature } from "react-icons/fa";
import { FaCameraRetro } from "react-icons/fa";
import { FaVoteYea } from "react-icons/fa";

function App() {
  const [user, setUser] = useState(null); // Initialize user state with null
  const [imageUrls, setImageUrls] = useState([]);
  const [userEmail, setUserEmail] = useState("Email@me.com");
  const [userFirstName, setUserFirstName] = useState("");
  //const [userName, setUserName] = useState("");
  const [folderName, setFolderName] = useState("defaultFolder");
  const [userData, setUserData] = useState(null);
  const [docId, setDocId] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [member, setMember] = useState(false); //used for permissions
  const [artist, setArtist] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  //const navigate = useNavigate();

  const signOutOnWindowClose = () => {
    window.addEventListener("beforeunload", () => {
      // Sign out the user when the window is closed
      signOut(auth)
        .then(() => {
          console.log("User signed out on window close.");
        })
        .catch((error) => {
          console.error("Error signing out:", error);
        });
    });
  };

  useEffect(() => {
    // Check if a user is signed in
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        console.log("AuthUser in App:", authUser);
        // User is signed in, set the user state
        setUser(authUser);
        // Get the email from authUser and store it
        const userEmail = authUser.email;
        const userUid = authUser.uid;
        console.log("from App.js userUid is: ", userUid);
        //console.log("AuthUser displayName:", authUser.displayName);
        setUserEmail(userEmail);
        const artistsCollectionRef = collection(db, "artists");
        // Create a query to find the document with the matching 'authRegID'
        const q = query(
          artistsCollectionRef,
          where("authRegID", "==", userUid)
        );
        try {
          const querySnapshot = await getDocs(q);
          if (!querySnapshot.empty) {
            // Extract and work with the user's data
            const userData = querySnapshot.docs[0].data();
            //set the folder
            const fullName = userData.first_name + "_" + userData.last_name;
            setFolderName(fullName);
            const myRole = userData.role;
            console.log("The role is", myRole);
            if (myRole === "member") {
              setMember(true);
            } else {
              setMember(false);
            }
            console.log("after set member, member is", member);
            //this acts like a session variable
            console.log("from line 58 in App, userData:", userData);
            setUserData(userData);
            console.log("from line 89 in App, urls", userData.imageURLs);
            setImageUrls(userData.imageURLs);
            setUserFirstName(userData.first_name);
            console.log("First name from App:", userFirstName);
            localStorage.setItem("fullName", fullName);
          } else {
            // No matching document found
            setUserData(null);
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          setUserData(null);
        }
      } else {
        // User is signed out, clear the user state
        setUser(null);
      }
    });

    // Clean up the subscription when the component unmounts
    return () => {
      unsubscribe();
      window.removeEventListener("beforeunload", signOutOnWindowClose);
    };
  }, []);

  return (
    <>
      <Router>
        <Navbar
          collapseOnSelect
          expand='md'
          bg='light'
          data-bs-theme='light'
          className='sticky-top'>
          <Container fluid>
            <Navbar.Brand
              className='d-flex align-items-center justify-items-left'
              href='/'>
              {" "}
              <Logo />
              <Row className='d-flex justify-items-left'>
                <Col lg={12}>Guest Artist Showcase 2027</Col>
                {userFirstName && (
                  <Col lg={12} className='welcome-name'>
                    Welcome {userFirstName}
                  </Col>
                )}
              </Row>
            </Navbar.Brand>
            <Navbar.Toggle onClick={toggleMenu} aria-controls='navbar-nav' />
            <Navbar.Collapse
              id='navbar-nav'
              className={`justify-content-end ${isMenuOpen ? "show" : ""}`}>
              <Nav className='justify-content-end'>
                {!user && (
                  <Nav.Link className='btn-nav first' href='/Register'>
                    Register
                  </Nav.Link>
                )}
                {!user && (
                  <Nav.Link className='btn-nav first' href='/SignIn'>
                    Sign In
                  </Nav.Link>
                )}

                {user && (
                  <Nav.Link className='right-aligned mb-3' href='/UserProfile'>
                    <BsFillFilePersonFill
                      color='green'
                      size={"18"}
                      align='right'
                    />{" "}
                    My Profile
                  </Nav.Link>
                )}

                {user && (
                  <Nav.Link
                    className='right-aligned mb-3'
                    href='/EditUserProfile'>
                    <FaEdit color='orange' size={"18"} align='right' /> Edit
                    Profile
                  </Nav.Link>
                )}

                {user && !member && (
                  <Nav.Link className='right-aligned mb-3' href='/Gallery'>
                    <FaCameraRetro color='violet' size={"18"} align='right' />{" "}
                    My Gallery
                  </Nav.Link>
                )}

                {user && member && (
                  <Nav.Link className='right-aligned mb-3' href='/ArtistsList'>
                    <FaVoteYea color='gray' size={"18"} align='right' /> Vote
                  </Nav.Link>
                )}

                {user && member && (
                  <Nav.Link
                    className='right-aligned mb-3'
                    href='/GuestArtistsList'>
                    <FaVoteYea color='gray' size={"18"} align='right' /> Totals
                  </Nav.Link>
                )}

                {user && member && (
                  <Nav.Link className='right-aligned mb-3' href='/MembersList'>
                    <FaSignature color='Black' size={"18"} align='center' />{" "}
                    Members
                  </Nav.Link>
                )}

                {/* {user && (
                  <Nav.Link className='right-aligned mb-3' href='/BioGenerator'>
                    <FaSignature color='Black' size={"18"} align='center' />{" "}
                    BioWriter
                  </Nav.Link>
                )} */}

                {user && (
                  <Nav.Link className='right-aligned mb-3' href='/SignOut'>
                    <FaSignOutAlt color='red' size={"18"} align='center' /> Sign
                    Out
                  </Nav.Link>
                )}
              </Nav>{" "}
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <Routes>
          {/* Begin Route Stack */}
          <Route path='' element={<Home user={user} />} />
          <Route
            path='/Register'
            element={
              <Registration1
                user={user}
                setUser={setUser}
                artist={artist}
                setArtist={setArtist}
                member={member}
                setMember={setMember}
              />
            }
          />
          <Route
            path='/SignIn'
            element={<SignIn user={user} setUser={setUser} />}
          />
          <Route
            path='/EditUserProfile'
            element={<EditUserProfile user={user} />}
          />
          <Route
            path='/UserProfile'
            element={
              <UserProfile
                user={user}
                folderName={folderName}
                setFolderName={setFolderName}
                imageUrls={imageUrls}
                setImageUrls={setImageUrls}
                docId={docId}
                setDocId={setDocId}
              />
            }
          />
          <Route path='/ImageUpload' element={<ImageUpload />} />
          <Route path='/ImageUploadModal' element={<ImageUploadModal />} />
          <Route
            path='/Gallery'
            element={
              <Gallery
                imageUrls={imageUrls}
                setImageUrls={setImageUrls}
                user={user}
                folderName={folderName}
                setFolderName={setFolderName}
                docId={docId} // Pass the docId prop to Gallery
                setDocId={setDocId} // If needed
                // docId={docId}
                // setDocId={setDocId}
              />
            }
          />
          <Route
            path='/SignOut'
            element={<SignOut user={user} setUser={setUser} />}
          />
          <Route path='/UserProfile' element={<UserProfile user={user} />} />

          <Route path='/ArtistsList' element={<ArtistsList user={user} />} />

          <Route path='/ForgotPassword' element={<ForgotPassword />} />

          <Route path='/TermsConditions' element={<TermsConditions />} />

          <Route path='/GuestArtistsList' element={<GuestArtistsList />} />

          <Route path='/MembersList' element={<MembersList />} />

          <Route path='/BioGenerator' element={<BioGenerator />} />

          <Route path='/Test' element={<TestFunctions />} />

          {/* //GuestArtistsList */}
        </Routes>
      </Router>
      <Footer />
    </>
  );
}

export default App;
